import { UserModel } from "../../../_metronic/global/models"
import { AuthModel } from "../../modules/auth"

export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const REMOVE_CURRENT_USER = 'REMOVE_CURRENT_USER'
export const SET_AUTH = 'SET_AUTH'
export const REMOVE_AUTH = 'REMOVE_AUTH'

export type ActionType = {
  type: 'SET_CURRENT_USER'
  payload: UserModel
} | {
  type: 'REMOVE_CURRENT_USER'
  payload: undefined
} | {
  type: 'UPDATE_CURRENT_USER'
  payload: UserModel
} | {
  type: 'SET_AUTH'
  payload: AuthModel
} | {
  type: 'REMOVE_AUTH'
  payload: undefined
}

export const setCurrentUser = (currentUser: UserModel ): ActionType => ({type: SET_CURRENT_USER, payload: currentUser})
export const removeCurrentUser = (): ActionType => ({type: REMOVE_CURRENT_USER, payload: undefined})
export const setAuth = (auth : AuthModel): ActionType => ({type: SET_AUTH, payload: auth})
export const removeAuth = (): ActionType => ({type: REMOVE_AUTH, payload: undefined})
